import { render, staticRenderFns } from "./TyProductTab.vue?vue&type=template&id=2e8610a3&"
import script from "./TyProductTab.vue?vue&type=script&lang=js&"
export * from "./TyProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports